import { MatchContactPersonType, MATCH_CONTACT_PERSON_TYPE_I18N } from '@pflegia/types/common/enums/match-contact-person-type.enum';

export { MatchContactPersonType as MatchesContactPersonType, MATCH_CONTACT_PERSON_TYPE_I18N };
